import React from "react"
import PropTypes from "prop-types"
import { OldIconButton } from "@kit/design/old-button"

export function DismissButton({ className, onDismiss, style }) {
  return (
    <OldIconButton
      icon="close"
      is="tertiary"
      size="sm"
      label="Close do more with apps"
      onClick={onDismiss}
      className={className}
      style={style}
    />
  )
}

DismissButton.propTypes = {
  className: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  style: PropTypes.object
}
